import { LinearProgress } from '@mui/material';
import { createContext, useContext, useMemo, useState } from 'react';

import { themeSelector } from '@/themes';

export const AppLoadingProviderContext = createContext({
  appLoading: true,
  setAppLoading: (_: boolean) => {},
});
export const useAppLoading = () => useContext(AppLoadingProviderContext);

type Props = {
  children: React.ReactNode;
};

const themeClassMap: Record<string, string> = {
  'light-theme': 'loading-bar-viewnexa-light',
  'dark-theme': 'loading-bar-viewnexa-dark',
  'light-theme-viewnexa': 'loading-bar-viewnexa-light',
  'dark-theme-viewnexa': 'loading-bar-viewnexa-dark',
};

const AppLoadingProvider = ({ children }: Props) => {
  const [appLoading, setAppLoading] = useState(true);

  const currentTheme = themeSelector.getTheme()?.name || 'light-theme';

  const value = useMemo(
    () => ({
      appLoading,
      setAppLoading,
    }),
    [appLoading]
  );

  return (
    <>
      {appLoading && (
        <div className="layout">
          <div className="app-loading-div fullHeight">
            <div className="app-loading-content">
              <div>
                <span className={themeClassMap[currentTheme] || 'loading-bar-viewnexa-light'} />
              </div>
              <div className="progress-container-viewnexa">
                <LinearProgress />
              </div>
            </div>
          </div>
        </div>
      )}
      <AppLoadingProviderContext.Provider value={value}>{children}</AppLoadingProviderContext.Provider>
    </>
  );
};

export default AppLoadingProvider;
